// Config panel for the "refresh_hub_config" action block
import React from 'react';
import {
  Box,
  Typography,
  Alert
} from '@mui/material';

const RefreshHubConfigConfig = ({ config, onChange, onSummaryChange }) => {
  // This block uses the location's hub automatically — no configuration needed
  React.useEffect(() => {
    onSummaryChange('Refresh hub config');
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography variant="caption" color="text.secondary">
        Forces the hub at this location to re-publish its full Qbus configuration.
        This triggers a getConfig command via MQTT.
      </Typography>

      <Alert severity="info" variant="outlined" sx={{ fontSize: '0.75rem' }}>
        No configuration needed. The hub is resolved automatically from the automation's location.
      </Alert>
    </Box>
  );
};

export default RefreshHubConfigConfig;
